import React, { useEffect, useState } from "react"
import { getAudioOutputDeviceData, setAudioOutputDevice } from "../../base/devices";
import { translate } from "../../base/i18n";
import { connect } from "../../base/redux";
import { Progressbar } from "../../base/canvas";
import { SelectDevice } from "./DeviceSelect";
import TestingAudio from "./TestingAudio";
import { getPropertyValue } from "../../base/settings";

function SelectAudioOutput({
    t, dispatch, list, deviceId, initVolume, isRoom,
    setSelectVolume
}) {
    const [ audioId, setAudioId ] = useState();
    const [ volume, setVolume ] = useState(initVolume);

    useEffect(() => {
        setAudioId(deviceId);
    }, [deviceId]);

    useEffect(() => {
        try {
            dispatch(setAudioOutputDevice(audioId));
        } catch {

        }        
    }, [audioId]);

    useEffect(() => {
        setVolume(initVolume);
    }, [initVolume]);

    useEffect(() => {
        setSelectVolume(volume);
    }, [volume]);

    const onMuteAudioOutput = (e) => {
        const muted = e.target.checked;

        if (muted) setVolume(0);
        else setVolume(50);
    }

    const onChange = (e) => {
        setVolume(e.target.value);
    };

    return (
        <>
            <dt> {t("device.audioOutputSetting")} </dt>
            <SelectDevice t={t} list={list} deviceId={deviceId} 
                setDeviceId={setAudioId} deviceStatus={{
                    type: "ok",
                    message: "device.microphoneOk"
                }}
            >
                { APP.function.setDevice.speakerTest && <TestingAudio deviceId={deviceId} volume={volume*0.01} /> }
            </SelectDevice>
            <dd className="mute_check nonSelect">
                { !isRoom && 
                    <>
                        <input type="checkbox" id="audioOutputMuteBtn" onChange={onMuteAudioOutput} />
                        <label className="muteCheckLabel" htmlFor="audioOutputMuteBtn">
                            <span>{t("device.hideSpeaker")}</span>
                        </label> 
                    </>
                }

                <Progressbar className="mute_range">
                    <input type="range" name="range"
                        min="0" max="100"
                        step="1"
                        value={volume}
                        onChange={onChange}
                        style={{ background: `linear-gradient(to right, #29abe2 0%, #29abe2 ${volume}%, #d5d4d3 ${volume}%, #d5d4d3 100%)`}}
                    />
                </Progressbar> 
            </dd>
        </>
    );
}

function _mapStateToProps(state) {
    const initVolume = getPropertyValue(state, "speakerVolume") * 100;
    
    return {
        list : getAudioOutputDeviceData(state),
        deviceId: APP.mateManagement.getAudioOutputDeviceId(),
        initVolume
    }
}

export default translate(connect(_mapStateToProps)(SelectAudioOutput));
